import { type DataObjectsManager, type IDataObject } from '@inpart-io/devtools-iap';
import {
    type AssetCategory,
    AssetCategoryValues,
    privateAssetProperties,
    privateAssetsManager,
    privateCompaniesManager,
    privateCompanyProperties,
    privateConsumerHealthAssetProperties,
    privateConsumerHealthAssetsManager,
    privateTechnologiesManager,
    privateTechnologyProperties
} from '@inpart-io/padme-iap';

import { PRIVATE_ASSET_MODULE } from '@/store/private-asset-module';
import { PRIVATE_COMPANY_MODULE } from '@/store/private-company-module';
import { PRIVATE_CONSUMER_HEALTH_ASSET_MODULE } from '@/store/private-consumer-health-asset-module';
import { PRIVATE_TECHNOLOGY_MODULE } from '@/store/private-technology-module';

export interface IAsetCategoryInfo {
    assetModule: string;
    assetProperties: string;
    assetManager: DataObjectsManager<IDataObject>;
}

export const assetCategoryMap: Map<AssetCategory, IAsetCategoryInfo> = new Map<AssetCategory, IAsetCategoryInfo>([
    [
        AssetCategoryValues.PHARMA_ASSET,
        {
            assetModule: PRIVATE_ASSET_MODULE,
            assetProperties: privateAssetProperties.DEFAULT,
            assetManager: privateAssetsManager
        }
    ],
    [
        AssetCategoryValues.TECHNO_SOLUTION,
        {
            assetModule: PRIVATE_TECHNOLOGY_MODULE,
            assetProperties: privateTechnologyProperties.DEFAULT,
            assetManager: privateTechnologiesManager
        }
    ],
    [
        AssetCategoryValues.COMPANY,
        {
            assetModule: PRIVATE_COMPANY_MODULE,
            assetProperties: privateCompanyProperties.DEFAULT,
            assetManager: privateCompaniesManager
        }
    ],
    [
        AssetCategoryValues.CONSUMER_HEALTH,
        {
            assetModule: PRIVATE_CONSUMER_HEALTH_ASSET_MODULE,
            assetProperties: privateConsumerHealthAssetProperties.DEFAULT,
            assetManager: privateConsumerHealthAssetsManager
        }
    ]
]);
